export const isDiscountCodeModuleEnabled = (state) => state.app.isDiscountCodeModuleEnabled;

export const getDiscountCodeResponse = (state) => state.app.apiDiscountCodeResponse;

export const isDiscountCodeValid = (state) => {
	if (!isDiscountCodeModuleEnabled(state)) {
		return false;
	}

	const discountCodeResponse = getDiscountCodeResponse(state);
	return !!(discountCodeResponse && discountCodeResponse.discountCode);
};

export const getDiscountCodePrice = (state) => {
	if (isDiscountCodeValid(state)) {
		const formValues = state.form.bookingForm.values;
		const response = getDiscountCodeResponse(state);

		return response.prices[formValues.currency.id];
	}

	return null;
}



// WEBPACK FOOTER //
// ./src/store/discountCodeSelector.jsx